import { render } from "./Becas.vue?vue&type=template&id=070863f2"
import script from "./Becas.vue?vue&type=script&lang=js"
export * from "./Becas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__